export const frontmatter = {
    "draft": true,
    "title": "Crear tu primer chatbot en 5 minutos",
    "description": "Aprende a configurar tu primer asistente de IA en OnnIA, entrenarlo con documentos y probarlo inmediatamente.",
    "sidebar_label": "Primer Chatbot",
    "sidebar_group": "quickstart",
    "sidebar_order": 3
}

export const toc = [
    {
        "depth": 2,
        "id": "que-vamos-a-construir",
        "value": "¿Qué vamos a construir?"
    },
    {
        "depth": 2,
        "id": "paso-a-paso-tu-chatbot-activo",
        "value": "Paso a paso: Tu chatbot activo"
    },
    {
        "depth": 2,
        "id": "consejos-pro-para-mejorar-tu-chatbot",
        "value": "Consejos Pro para mejorar tu chatbot"
    },
    {
        "depth": 2,
        "id": "resolucion-de-dudas-rapidas",
        "value": "Resolución de dudas rápidas"
    },
    {
        "depth": 3,
        "id": "como-conecto-este-chatbot-a-mi-numero-de-whatsapp",
        "value": "¿Cómo conecto este chatbot a mi número de WhatsApp?"
    },
    {
        "depth": 3,
        "id": "que-ocurre-si-la-ia-no-sabe-responder",
        "value": "¿Qué ocurre si la IA no sabe responder?"
    }
]